<script>
// Allows stubbing BaseLink in unit tests
const BaseLink = 'BaseLink'

export default {
  // Functional components are stateless, meaning they can't
  // have data, computed properties, etc and they have no
  // `this` context.
  functional: true,
  props: {
    routes: {
      type: Array,
      required: true,
    },
  },
  // Render functions are an alternative to templates
  render(h, { props, $style = {} }) {
    function getRouteTitle(route) {
      return typeof route.title === 'function' ? route.title() : route.title
    }

    // Functional components are the only components allowed
    // to return an array of children, rather than a single
    // root node.
    return props.routes.map((route) => (
      <BaseLink
        tag='li'
        key={route.name}
        to={route}
        exact-active-class={$style.active}
      >
        <a>{getRouteTitle(route)}</a>
      </BaseLink>
    ))
  },
}
</script>

<style lang="scss" scoped module>
@import '@design';
a {
  color: white !important;
  text-decoration: none !important;
}
.active a {
  // font-weight: 600;
  color: $color-link-text-active !important;
  text-decoration: none;
  cursor: default;
}
li {
  padding: 0.4rem 0.7rem;
  padding-left: 1rem;
  // margin: 0;
}
li.active {
  background-color: #005896;
  border-radius: 8px 8px 0px 0px;
}
</style>
